<template>
  <div>
    <div class="chartFilter">
      <select
        v-model="alertTypeFilter"
        @change="filterData('alert')"
        class="country_select toUpper"
        name="country"
      >
        <option value="">Select Alert Type</option>
        <option value="All">All</option>
        <option v-for="(alerts, idx) in alertTypes" :key="idx" :value="alerts">
          {{ alerts }}
        </option>
      </select>
      <select
        @change="filterData('age', $event.target.value)"
        class="country_select toUpper"
        name="country"
      >
        <option value="">Select Age Range</option>
        <option value="0-20">0-20</option>
        <option value="21-40">21-40</option>
        <option value="41-60">41-60</option>
        <option value="61-80">61-80</option>
        <option value="81-100">81-100</option>
      </select>
    </div>
    <div class="content-grid">
      <div class="row align-items-stretch no-gutters">
        <div class="col-lg-12">
          <div class="card alertlist_table">
            <div class="card-header" style="justify-content: space-between">
              <div>{{ $t("Sidebar.alert") }}</div>
              <!-- <select v-model="listType" class="form-control" style="width:10%" @change="typeChange()">
                            <option value="index">{{ $t("Overview.index") }}</option>
                            <option value="contact">{{ $t("Overview.contacts") }}</option>
                        </select> -->
            </div>
            <div class="card-body">
              <v-client-table
                id="alert_table"
                :columns="columns"
                :data="userListDataArrary"
                :options="options"
              >
              </v-client-table>
              <div>
                <p class="m-0">
                  <i class="fa fa-circle" style="color: #0dad0da3"></i> : <= 5
                  Days
                </p>
                <p class="m-0">
                  <i class="fa fa-circle" style="color: #ff23008c"></i> : <= 10
                  Days
                </p>
                <p class="m-0">
                  <i class="fa fa-circle" style="color: #f10000 !important"></i>
                  : > 10 Days
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JQuery from "jquery";
let $ = JQuery;
import ApiServices from "../service/ApiServices";
import { _ } from "vue-underscore";
export default {
  name: "home",
  components: {},
  data() {
    return {
      alertDataFlag: false,
      userData: JSON.parse(sessionStorage.getItem("userData")),
      columns: 
    //   ['Alert Name', 'Due', 'Registered By', 'Client Type', 'First Name', 'Date of Birth', 'Age', 'Sex', 'Phone Number (Primary)', 'Date of initiation of TB treatment']
      [
        "Client Type",
        "First Name",
        'Date of Birth',
        "Age",
        'Sex',
        "Registered By",
        "TB Testing Referral Alert",
        "TB Treatment Initiation alert",
        "TB Re-testing Alert",
        "TPT initiation alert",
        // "TBI Testing Referral Alert",
        // "TBI Re-testing Alert",
      ],
      masterListData: [],
      userListDataArrary: [],
      indexList: [],
      contactList: [],
      options: {
        headings: {
          "LTBI Treatment Referral Alert": "TBI Treatment Referral Alert",
          "LTBI Testing Referral Alert": "TBI Testing Referral Alert",
          "LTBI Re-testing Alert": "TBI Re-testing Alert",
        },
        texts: {
          filterPlaceholder: "Search",
        },
        sortIcon: {
          down: "fas fa-long-arrow-alt-up",
          up: "fas fa-long-arrow-alt-down",
        },
        rowClassCallback: function (row) {
          return row.selected ? "info" : "";
        },
        cellClasses: {
          "TB Testing Referral Alert": [
            {
              class: "alertLow",
              condition: (row) =>
                parseInt(row["TB Testing Referral Alert"]) <= 5,
            },
            {
              class: "alertMild",
              condition: (row) =>
                parseInt(row["TB Testing Referral Alert"]) <= 10,
            },
            {
              class: "alertHigh",
              condition: (row) =>
                parseInt(row["TB Testing Referral Alert"]) > 10,
            },
          ],
          "TB Treatment Referral Alert": [
            {
              class: "alertLow",
              condition: (row) =>
                parseInt(row["TB Treatment Referral Alert"]) <= 5,
            },
            {
              class: "alertMild",
              condition: (row) =>
                parseInt(row["TB Treatment Referral Alert"]) <= 10,
            },
            {
              class: "alertHigh",
              condition: (row) =>
                parseInt(row["TB Treatment Referral Alert"]) > 10,
            },
          ],
          "TB Re-testing Alert": [
            {
              class: "alertLow",
              condition: (row) => parseInt(row["TB Re-testing Alert"]) <= 5,
            },
            {
              class: "alertMild",
              condition: (row) => parseInt(row["TB Re-testing Alert"]) <= 10,
            },
            {
              class: "alertHigh",
              condition: (row) => parseInt(row["TB Re-testing Alert"]) > 10,
            },
          ],
          "TBI Treatment Referral Alert": [
            {
              class: "alertLow",
              condition: (row) =>
                parseInt(row["TBI Treatment Referral Alert"]) <= 5,
            },
            {
              class: "alertMild",
              condition: (row) =>
                parseInt(row["TBI Treatment Referral Alert"]) <= 10,
            },
            {
              class: "alertHigh",
              condition: (row) =>
                parseInt(row["TBI Treatment Referral Alert"]) > 10,
            },
          ],
          "TBI Testing Referral Alert": [
            {
              class: "alertLow",
              condition: (row) =>
                parseInt(row["TBI Testing Referral Alert"]) <= 5,
            },
            {
              class: "alertMild",
              condition: (row) =>
                parseInt(row["TBI Testing Referral Alert"]) <= 10,
            },
            {
              class: "alertHigh",
              condition: (row) =>
                parseInt(row["TBI Testing Referral Alert"]) > 10,
            },
          ],
          "TBI Re-testing Alert": [
            {
              class: "alertLow",
              condition: (row) => parseInt(row["TBI Re-testing Alert"]) <= 5,
            },
            {
              class: "alertMild",
              condition: (row) => parseInt(row["TBI Re-testing Alert"]) <= 10,
            },
            {
              class: "alertHigh",
              condition: (row) => parseInt(row["TBI Re-testing Alert"]) > 10,
            },
          ],
        },
      },
      listType: "index",
      alertTypeFilter: "",
      alertTypes: [
        "TB Testing Referral Alert",
        "TB Treatment Referral Alert",
        "TB Re-testing Alert",
        "TBI Treatment Referral Alert",
        "TBI Testing Referral Alert",
        "TBI Re-testing Alert",
      ],
    };
  },
  methods: {
    filterData(type, value) {
      // console.log(type,value,this.masterListData)
      if (type == "alert") {
        if (this.alertTypeFilter != "All") {
          this.columns = [
            "UIC",
            "Client Type",
            "Given Name",
            "Family Name",
            "Age",
            "Registration Date",
            "By User",
          ];
          this.columns.push(this.alertTypeFilter);
        } else {
          this.columns = [
            "UIC",
            "Client Type",
            "Given Name",
            "Family Name",
            "Age",
            "Registration Date",
            "By User",
            "TB Testing Referral Alert",
            "TB Treatment Referral Alert",
            "TB Re-testing Alert",
            "TBI Treatment Referral Alert",
            "TBI Testing Referral Alert",
            "TBI Re-testing Alert",
          ];
        }
      } else if (type == "age") {
        var min = value.split("-")[0];
        var max = value.split("-")[1];
        this.userListDataArrary = _.filter(
          this.masterListData,
          function (data) {
            if (parseInt(data["Age"]) >= min && parseInt(data["Age"]) <= max) {
              return data;
            }
          }
        );
        // this.masterListData.filter(data => { parseInt(data['Age']) > min && parseInt(data['Age']) < max })
      }
    },
    typeChange() {
      if (this.listType == "index") {
        this.userListDataArrary = this.indexList;
        if (this.userData.programid == "1262097")
          this.columns = [
            "UIC",
            "Client Type",
            "index_Name",
            "index_Age",
            "index_Gender",
            "Registration Date",
            "By User",
            "LTBI Testing Referral Alert",
            "LTBI Treatment Referral Alert",
            "TB Testing Referral Alert",
            "TB Treatment Referral Alert",
            "LTBI Re-testing Alert",
            "TB Re-testing Alert",
          ];
      } else {
        this.userListDataArrary = this.contactList;
        if (this.userData.programid == "1262097")
          this.columns = [
            "UIC",
            "Client Type",
            "Contact Name",
            "Contact Age",
            "Contact Gender",
            "Registration Date",
            "By User",
            "LTBI Testing Referral Alert",
            "LTBI Treatment Referral Alert",
            "TB Testing Referral Alert",
            "TB Treatment Referral Alert",
            "LTBI Re-testing Alert",
            "TB Re-testing Alert",
          ];
      }
    },
    getAlertList() {
      this.$root.isLoading = true;
      var instance = {
        programid: this.userData.programid,
        orgid: this.userData.orgid,
      };
      let self = this;
      let trackedEntityUrl =
        "metadata?programs:filter=id:eq:"+this.userData.programid+"&programs:fields=:owner,displayName,userAccesses,programTrackedEntityAttributes[:owner,trackedEntityAttribute[id,name,formName,description,valueType,optionSet,domainType]],programStages[:owner,user[id,name],displayName,attributeValues[:all,attribute[id,name,displayName]],programStageDataElements[:owner,renderType,formName,dataElement[id,displayName,formName,description,compulsory,valueType,optionSet,domainType]],notificationTemplates[:owner,displayName],dataEntryForm[:owner],programStageSections[:owner,displayName,dataElements[id,displayName]]]";
      ApiServices.RestGetCall(trackedEntityUrl).then((r) => {
        console.log(r);
        const listOfFields = r.programs[0].programTrackedEntityAttributes;
        const fieldToDisplay1 = listOfFields.filter((obj) => obj);
        ApiServices.RestGetCall(
          "alerts/genericalertlist?ouid=HRvE77FT8Gh&programid="+this.userData.programid+"&pageSize=100&offset=0&skipPaging=false&paging=false&page=1&totalPages=false"
        ).then((res) => {
            this.$root.isLoading = false;
          let labelArr = [];
          let masterAlertdata = res.data;
          masterAlertdata.map((alertdata) => {
            let obj = {};
            obj['Alert Name'] = alertdata.alertname
            obj['Due'] = alertdata.duedays

            if (alertdata.alertname == `TB Infection Testing Referral Alert`) {
             obj["TB Testing Referral Alert"] = parseInt(alertdata.duedays);
             obj["TB Treatment Referral Alert"] = "";
             obj["TB Re-testing Alert"] = "";
             obj["TBI Treatment Referral Alert"] = "";
             obj["TBI Testing Referral Alert"] = "";
             obj["TBI Re-testing Alert"] = "";
            }
            if (alertdata.alertname == `TB Treatment Referral Alert`) {
             obj["TB Testing Referral Alert"] = "";
             obj["TB Treatment Referral Alert"] = parseInt(alertdata.duedays);
             obj["TB Re-testing Alert"] = "";
             obj["TBI Treatment Referral Alert"] = "";
             obj["TBI Testing Referral Alert"] = "";
             obj["TBI Re-testing Alert"] = "";
            }
            if (alertdata.alertname == `TB Re-testing Alert`) {
             obj["TB Testing Referral Alert"] = "";
             obj["TB Treatment Referral Alert"] = "";
             obj["TB Re-testing Alert"] = parseInt(alertdata.duedays);
             obj["TBI Treatment Referral Alert"] = "";
             obj["TBI Testing Referral Alert"] = "";
             obj["TBI Re-testing Alert"] = "";
            }
            if (alertdata.alertname == `TBI Treatment Referral Alert`) {
             obj["TB Testing Referral Alert"] = "";
             obj["TB Treatment Referral Alert"] = "";
             obj["TB Re-testing Alert"] = "";
             obj["TBI Treatment Referral Alert"] = parseInt(alertdata.duedays);
             obj["TBI Testing Referral Alert"] = "";
             obj["TBI Re-testing Alert"] = "";
            }
            if (
              alertdata.alertname == `TBI Testing Referral Alert` ||
              alertdata.alertname == "TB Infection Testing Referral Alert"
            ) {
             obj["TB Testing Referral Alert"] = "";
             obj["TB Treatment Referral Alert"] = "";
             obj["TB Re-testing Alert"] = "";
             obj["TBI Treatment Referral Alert"] = "";
             obj["TBI Testing Referral Alert"] = parseInt(alertdata.duedays);
             obj["TBI Re-testing Alert"] = "";
            }
            if (alertdata.alertname == `TBI Re-testing Alert`) {
             obj["TB Testing Referral Alert"] = "";
             obj["TB Treatment Referral Alert"] = "";
             obj["TB Re-testing Alert"] = "";
             obj["TBI Treatment Referral Alert"] = "";
             obj["TBI Testing Referral Alert"] = "";
             obj["TBI Re-testing Alert"] = parseInt(alertdata.duedays);
            }
            fieldToDisplay1.forEach((item) => {
              
              if (item.trackedEntityAttribute) {
                if (alertdata.hasOwnProperty(item.trackedEntityAttribute.id)) {
                  obj[item.trackedEntityAttribute.formName] =
                    alertdata[item.trackedEntityAttribute.id];
                }
              } else {
                if (alertdata.hasOwnProperty(item.dataElement.id)) {
                  obj[item.dataElement.formName] =
                    alertdata[item.dataElement.id];
                }
              }
            });
            labelArr.push(obj);
          });
          console.log(labelArr);
          this.userListDataArrary = labelArr
        });
      });
    //   ApiServices.RestPostCall(
    //     "ltbi/generic/common/dashboard/alerts",
    //     instance
    //   ).then((res) => {
    //     let checkString = "_ID";
    //     let checkString2 = "index_";
    //     if (res.data.length > 0) {
    //       this.alertDataFlag = true;
    //       $.each(res.data, function (key, val) {
    //         if (val.regDate) {
    //           val["Registration Date"] = val.regDate;
    //           delete val.regDate;
    //         }
    //         if (val.byUser) {
    //           val["By User"] = val.byUser;
    //           delete val.byUser;
    //         }
    //         if (val.alertname == `TB Testing Referral Alert`) {
    //           val["TB Testing Referral Alert"] = parseInt(val.duedays);
    //           val["TB Treatment Referral Alert"] = "";
    //           val["TB Re-testing Alert"] = "";
    //           val["TBI Treatment Referral Alert"] = "";
    //           val["TBI Testing Referral Alert"] = "";
    //           val["TBI Re-testing Alert"] = "";
    //         }
    //         if (val.alertname == `TB Treatment Referral Alert`) {
    //           val["TB Testing Referral Alert"] = "";
    //           val["TB Treatment Referral Alert"] = parseInt(val.duedays);
    //           val["TB Re-testing Alert"] = "";
    //           val["TBI Treatment Referral Alert"] = "";
    //           val["TBI Testing Referral Alert"] = "";
    //           val["TBI Re-testing Alert"] = "";
    //         }
    //         if (val.alertname == `TB Re-testing Alert`) {
    //           val["TB Testing Referral Alert"] = "";
    //           val["TB Treatment Referral Alert"] = "";
    //           val["TB Re-testing Alert"] = parseInt(val.duedays);
    //           val["TBI Treatment Referral Alert"] = "";
    //           val["TBI Testing Referral Alert"] = "";
    //           val["TBI Re-testing Alert"] = "";
    //         }
    //         if (val.alertname == `TBI Treatment Referral Alert`) {
    //           val["TB Testing Referral Alert"] = "";
    //           val["TB Treatment Referral Alert"] = "";
    //           val["TB Re-testing Alert"] = "";
    //           val["TBI Treatment Referral Alert"] = parseInt(val.duedays);
    //           val["TBI Testing Referral Alert"] = "";
    //           val["TBI Re-testing Alert"] = "";
    //         }
    //         if (
    //           val.alertname == `TBI Testing Referral Alert` ||
    //           val.alertname == "TB Infection Testing Referral Alert"
    //         ) {
    //           val["TB Testing Referral Alert"] = "";
    //           val["TB Treatment Referral Alert"] = "";
    //           val["TB Re-testing Alert"] = "";
    //           val["TBI Treatment Referral Alert"] = "";
    //           val["TBI Testing Referral Alert"] = parseInt(val.duedays);
    //           val["TBI Re-testing Alert"] = "";
    //         }
    //         if (val.alertname == `TBI Re-testing Alert`) {
    //           val["TB Testing Referral Alert"] = "";
    //           val["TB Treatment Referral Alert"] = "";
    //           val["TB Re-testing Alert"] = "";
    //           val["TBI Treatment Referral Alert"] = "";
    //           val["TBI Testing Referral Alert"] = "";
    //           val["TBI Re-testing Alert"] = parseInt(val.duedays);
    //         }
    //         if (!val.duedays) {
    //           val.duedays = 0;
    //         }
    //         delete val.trackedentityinstanceid;
    //         delete val.trackedentityinstanceuid;
    //         delete val.sysUIC;
    //         delete val.lat;
    //         delete val.long;
    //         delete val.status;
    //         delete val.instanceId;
    //         var temp = Object.keys(val);
    //         delete val.duedays;
    //         delete val.alertname;
    //         delete val.message;
    //         if (val["Client Type"] == "Contact") {
    //           temp.map((items) => {
    //             if (items.indexOf(checkString) != -1) {
    //               delete val[items];
    //             }
    //             if (items.indexOf(checkString2) != -1) {
    //               delete val[items];
    //             }
    //           });
    //           self.contactList.push(val);
    //         } else {
    //           temp.map((items) => {
    //             if (items.indexOf(checkString) != -1) {
    //               delete val[items];
    //             }
    //             if (items.indexOf("Contact") != -1) {
    //               delete val[items];
    //             }
    //           });
    //           self.indexList.push(val);
    //         }
    //       });
    //       if (this.listType == "index" && this.indexList.length > 0) {
    //         // this.indexList = res.data
    //         this.userListDataArrary = this.indexList;
    //         if (this.userData.programid == "1262097")
    //           this.columns = [
    //             "UIC",
    //             "Client Type",
    //             "index_Name",
    //             "index_Age",
    //             "index_Gender",
    //             "Registration Date",
    //             "By User",
    //             "LTBI Testing Referral Alert",
    //             "LTBI Treatment Referral Alert",
    //             "TB Testing Referral Alert",
    //             "TB Treatment Referral Alert",
    //             "LTBI Re-testing Alert",
    //             "TB Re-testing Alert",
    //           ];
    //       } else if (this.contactList.length > 0) {
    //         // this.contactList = res.data
    //         this.userListDataArrary = this.contactList;
    //         if (this.userData.programid == "1262097")
    //           this.columns = [
    //             "UIC",
    //             "Client Type",
    //             "Contact Name",
    //             "Contact Age",
    //             "Contact Gender",
    //             "Registration Date",
    //             "By User",
    //             "LTBI Testing Referral Alert",
    //             "LTBI Treatment Referral Alert",
    //             "TB Testing Referral Alert",
    //             "TB Treatment Referral Alert",
    //             "LTBI Re-testing Alert",
    //             "TB Re-testing Alert",
    //           ];
    //       }
    //       this.masterListData = this.userListDataArrary;
    //       // this.userListDataArrary = res.data
    //       // console.log(tes)
    //     }
    //     this.$root.isLoading = false;
    //   });
    },
  },
  mounted() {
    let langLocal = JSON.parse(sessionStorage.getItem("langLocal"));
    for (let lang in langLocal) {
      console.log(lang, langLocal[lang]);
      this.$i18n.setLocaleMessage(lang, langLocal[lang]);
    }
    $(".VueTables__table").removeClass(
      "table-striped table-bordered table-hover"
    );
    this.getAlertList();
  },
};
</script>
